import axios from "axios"
import { Booking } from "../../../types/BookingWithCert"

export const sendPDFEmail = (serverURL: string, booking: Booking, type: string) => {
    axios.post(`${serverURL}/send-email?type=${type}`, booking)
        .catch((err) => console.log(err))
}
